import { Component, Vue, Watch } from "vue-property-decorator";
import { parsePhoneNumber, AsYouType } from "libphonenumber-js";
import { getAllCountries, getCountryByCode } from "@/plugins/countries_helper";
import { Getter } from "vuex-class";

@Component({})
export default class CellphoneInput extends Vue {
  @Getter getCountry;

  currentCountry = null;
  isSelector = false;
  inputValue = "";
  wrong = "";
  isInputFocus = false;
  countryCode = "";

  regex = /([+| ])/g;
  regex1 = /([A-Za-z])+/g;

  get getAllCountries() {
    return getAllCountries();
  }

  mounted() {
    this.currentCountry = getCountryByCode("CO");
    if (this.getCountry && this.getCountry.id === 3) {
      this.currentCountry = getCountryByCode("MX");
    }
  }

  @Watch("currentCountry", { deep: true })
  onCurrentCountryChange() {
    const ex = "123";
    this.inputValue = "";
    if (this.currentCountry && this.currentCountry.code) {
      const val = parsePhoneNumber(ex, this.currentCountry.code);
      if (val && val.countryCallingCode) {
        this.countryCode = val.countryCallingCode.toString();
      }
    } else {
      this.countryCode = "57";
    }
    this._typeValue();
  }

  _typeValue() {
    let response = {
      cellphone: null,
      wrong: null,
      enableButton: false,
    };
    this.inputValue = this.inputValue.replace(this.regex1, "");
    try {
      if (this.inputValue !== "") {
        const val = parsePhoneNumber(this.inputValue, this.currentCountry.code);
        let res = new AsYouType().input(val.number as any);
        this.inputValue = res.split(`+${this.countryCode} `)[1];
        res = res.replace(this.regex, "");

        if (val.isValid()) {
          response.cellphone = res;
        } else if (val.isPossible() || this.inputValue.length === 0) {
          response.wrong = "";
        } else {
          response.wrong = "Ingresa un número de celular válido";
        }
      } else {
        response.cellphone = null;
        response.wrong = null;
      }
    } catch (error) {
      response.wrong = "Ingresa un número de celular válido";
    }
    if (this.inputValue && this.inputValue.length && this.inputValue.length <= 15) {
      response.enableButton = true;
    }
    this.$emit("cellphone-value", response);
  }

  _selector() {
    this.isSelector = !this.isSelector;
  }

  selectCountry(country) {
    this.currentCountry = country;
    this._selector();
  }

  _onClickOutside() {
    this.isSelector = false;
  }

  _onPressEnter() {
    this.$emit("press-enter");
  }

  truncate(value: String) {
    let response = value;
    if (value && value.length && value.length > 15) {
      response = value.substr(0, 15) + "...";
    }
    return response;
  }

  _countryFlag(country) {
    let response = "";
    if (country && country.code) {
      response = `https://dyclassroom.com/image/flags/${country.code.toLowerCase()}.png`;
    }
    return response;
  }
}
